import { ProfilingContext } from './profilingContext';
import { CreateStrategyProvider } from '../createStrategy';

export const ProfilingProvider = CreateStrategyProvider(ProfilingContext);
